import { CoreModule } from './core/core.module';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { MyApp } from './app.component';
import { ChecklistPageModule } from '../pages/checklist/checklist.module';
import { ImpressumPageModule } from '../pages/Impressum/Impressum.module';
import { DatenschutzPageModule } from '../pages/Datenschutz/Datenschutz.module';
import { SearchPageModule } from '../pages/search/search.module'; 

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { MiddlewareService } from '../services/middleware.service';
import { SingletonKlickhandlerService } from '../services/klickhandler.service';

import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';

import { GlobalsSingleton } from './core/GlobalsSingleton';


@NgModule({
  declarations: [
	MyApp
  ],
  imports: [
	BrowserModule,
	IonicModule.forRoot(MyApp),
	IonicStorageModule.forRoot(),
	ChecklistPageModule,
	ImpressumPageModule,
	DatenschutzPageModule,
	SearchPageModule,
	HttpModule,
	HttpClientModule,
	CoreModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
	MyApp
  ],
  providers: [
	GlobalsSingleton,
	MiddlewareService,
	SingletonKlickhandlerService,
	StatusBar,
	SplashScreen,
	{provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts